import React from 'react';
//import {Link} from "react-router-dom";
import "./style.css";


// exemplo de uso:
//const btn_extra=<Btn_dj lista={[{name:"aaaaaa"},{name:"aaaaaa"},{name:"aaaaaa"}]}/>

function Btn_dj(props) {
  // if (props.listaa===[]) return <></>

  const lista = props.lista ||  [{to:props.to,texto:props.texto}]
  //const lista = [{to:props.to,name:props.name}]
  const btns = lista
    .map((
      {to, texto, dowload,className:_className, bloquado, onClick, /*...args */}, id
    ) => (
      <a
        href={to}
        key={`btn_${id}`}
        alt={texto}
        className={`abrir btn ${_className||""} ${!!bloquado ? 'btn-lock' : " "}`}
        target="_blank"
        rel="noopener noreferrer"
        dowload={dowload}
        onClick={onClick}
        /*{...args}*/
      > {texto} </a>
    )
  );
  return (
    <div className="btn_nav">
    {btns}
    </div>
  )
}
export default Btn_dj;
